/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wherewilltheeventbeheld5Inputs */

const en_wherewilltheeventbeheld5 = /** @type {(inputs: Wherewilltheeventbeheld5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where will the event be held?`)
};

const de_wherewilltheeventbeheld5 = /** @type {(inputs: Wherewilltheeventbeheld5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo findet das Event statt?`)
};

/**
* | output |
* | --- |
* | "Where will the event be held?" |
*
* @param {Wherewilltheeventbeheld5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const wherewilltheeventbeheld5 = /** @type {((inputs?: Wherewilltheeventbeheld5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wherewilltheeventbeheld5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wherewilltheeventbeheld5(inputs)
	return de_wherewilltheeventbeheld5(inputs)
});
export { wherewilltheeventbeheld5 as "whereWillTheEventBeHeld" }